import parse, { HTMLReactParserOptions } from 'html-react-parser';

export const htmlReactParser = (html: string, options?: HTMLReactParserOptions) => {
  if (typeof html === 'string') {
    return parse(html, options);
  }
  return html;
};

export const rawHtmlParser = (html: string) => {
  // return htmlElement wrapped inside div
  // beware of passing string which are not allowed inside div, like thead
  if (typeof html === 'string') {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    return tempElement;
  }
  return null;
};

export const parseAnchorTag = (html: string) => {
  const parentElement = rawHtmlParser(html);
  if (parentElement !== null) {
    return parentElement.getElementsByTagName('a')[0];
  }
  return null;
};

export const parseParagraphTag = (html: string) => {
  const parentElement = rawHtmlParser(html);
  if (parentElement !== null) {
    return parentElement.getElementsByTagName('p')[0];
  }
  return null;
};
